import { render, staticRenderFns } from "./SummarySoldProduct.vue?vue&type=template&id=d54366aa&"
import script from "./SummarySoldProduct.vue?vue&type=script&lang=js&"
export * from "./SummarySoldProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports